module.exports = __webpack_public_path__ + "static/media/World_of_Crucible_Banner_Text.f5d1bb7f.png";